import * as React from "react";
import {IconOrImage} from "FormBuilder/Fields/Core/Interfaces/IconOrImage";
import {FormBuilderDesignerModel} from "ProductFieldBuilder/Designer/FormBuilderDesigner/Core/FormBuilderDesigner.Model";
import {FontAwesomeIcon} from "shared/core/Controls/FontAwesome/FontAwesomeIcon";
import {CSSProperties} from "react";

export class IconOrImageDisplayer extends React.Component<IconOrImageDisplayerProps, IconOrImageDisplayerState> {
    static defaultProps: Partial<IconOrImageDisplayerProps> = {
        form:null,
        Size:18
    };

    constructor(props: IconOrImageDisplayerProps) {
        super(props);
        this.state = {};
    }

    public render() {
        let icon=this.props.icon;
        let form=this.props.form;
        if(icon==null||icon.ImageType=="none")
            return null;

        if(icon.ImageType=="icon") {
            if(form!=null)
                icon=form.GetIcon(icon.Ref.Name) as any;
            else
                icon=icon.Ref;

            return (
                <div className={'RNIconOrImage'} style={{
                    width: '100%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    height: '100%',
                    color: 'white',
                    fontSize: this.props.Size,...this.props.styles
                }}>
                    <FontAwesomeIcon icon={icon}/>
                </div>
            );
        }

        if(icon.ImageType=='image')
            return (
                <div style={{width:'100%',display:'flex',alignItems:'center',justifyContent:'center',height:'100%',color:'white',fontSize:18,...this.props.styles}}>
                    <img style={{width:this.props.Size,height:this.props.Size}} src={icon.Ref.URL} alt={''}/>
                </div>
            )
    }
}


//#region ----------------------------------------------------"State and props"------------------------------------------------------------------------------------
interface IconOrImageDisplayerProps {
    icon:IconOrImage;
    form?:FormBuilderDesignerModel;
    styles:CSSProperties;
    Size:number;
}

interface IconOrImageDisplayerState {

}

//#endregion "My Region"